/**
 * This store will mainly be used by search components
 */
export default {
  state: {
    areaOfSearchOptionsSelected: [],
    locationsSelected: [],
    resourceSelected: "LESSON",
    resourceTypesSelected: [],
    subjectsSelected: [],
    levelsSelected: [],
    syllabusSelected: null,
    parentTopicsSelected: [],
    topicsSelected: [],
    learningOutcomeSelected: [],
    authorsAndCollaborators: [],
    authorAndCollaboratorIds: [],
    search: {
      keyword: "",
      hasResourceFilter: false,
    },
    mySubjects: [],
    otherSubjects: [],
    subjectData: [],
    levelAndStreamData: {},
    contentMapData: [],
    levelAndStreamByGroup: {},
    selectionList: {},
    questionPartsSelectionList: {},
    parent: "",
  },
  resetSubjectAndLevel() {
    this.state.subjectsSelected = [];
    this.state.levelsSelected = [];
  },
  resetTopics() {
    this.state.parentTopicsSelected = [];
    this.state.topicsSelected = [];
    this.state.learningOutcomeSelected = [];
    this.state.syllabusSelected = null;
  },
  resetFilters() {
    this.state.locationsSelected = [];
    this.state.resourceSelected = "LESSON"; // default to modules
    this.state.areaOfSearchOptionsSelected = [];
    this.state.resourceTypesSelected = [];
    this.state.subjectsSelected = [];
    this.state.levelsSelected = [];
    this.state.syllabusSelected = null;
    this.state.parentTopicsSelected = [];
    this.state.topicsSelected = [];
    this.state.learningOutcomeSelected = [];
    this.state.authorsAndCollaborators = [];
    this.state.authorAndCollaboratorIds = [];
    this.state.parent = "";
  },
  resetFiltersForLesson() {
    this.state.locationsSelected = [];
    this.state.areaOfSearchOptionsSelected = [];
    this.state.subjectsSelected = [];
    this.state.levelsSelected = [];
    this.state.syllabusSelected = null;
    this.state.parentTopicsSelected = [];
    this.state.topicsSelected = [];
    this.state.learningOutcomeSelected = [];
    this.state.authorsAndCollaborators = [];
    this.state.authorAndCollaboratorIds = [];
    this.state.parent = "";
  },
  resetFiltersForQuestion() {
    this.state.locationsSelected = [];
    this.state.areaOfSearchOptionsSelected = [];
    this.state.resourceTypesSelected = [];
    this.state.subjectsSelected = [];
    this.state.levelsSelected = [];
    this.state.syllabusSelected = null;
    this.state.parentTopicsSelected = [];
    this.state.topicsSelected = [];
    this.state.learningOutcomeSelected = [];
    this.state.authorsAndCollaborators = [];
    this.state.authorAndCollaboratorIds = [];
    this.state.parent = "";
  },
  resetFiltersForMedia() {
    this.state.locationsSelected = [];
    this.state.resourceTypesSelected = [];
  },
  resetAddFromLibrarySearchFilters(locations, resource, resourceTypes) {
    this.state.locationsSelected = locations;
    this.state.resourceSelected = resource; // default to modules
    this.state.areaOfSearchOptionsSelected = [];
    this.state.resourceTypesSelected = resourceTypes;
    this.state.subjectsSelected = [];
    this.state.levelsSelected = [];
    this.state.syllabusSelected = null;
    this.state.parentTopicsSelected = [];
    this.state.topicsSelected = [];
    this.state.learningOutcomeSelected = [];
    this.state.authorsAndCollaborators = [];
    this.state.authorAndCollaboratorIds = [];
    this.state.parent = "";
  },
  getAreaOfSearchOptionsSelected() {
    return this.state.areaOfSearchOptionsSelected;
  },
  setAreaOfSearchOptionsSelected(areaOfSearchOptionsSelected) {
    this.state.areaOfSearchOptionsSelected = areaOfSearchOptionsSelected;
  },
  getLocationsSelected() {
    return this.state.locationsSelected;
  },
  setLocationsSelected(locationsSelected) {
    this.state.locationsSelected = locationsSelected;
  },
  getResourceSelected() {
    return this.state.resourceSelected;
  },
  setResourceSelected(resourceSelected) {
    this.state.resourceSelected = resourceSelected;
  },
  getResourceTypesSelected() {
    return this.state.resourceTypesSelected;
  },
  setResourceTypesSelected(resourceTypesSelected) {
    this.state.resourceTypesSelected = resourceTypesSelected;
  },
  getSubjectsSelected() {
    return this.state.subjectsSelected;
  },
  setSubjectsSelected(subjectsSelected) {
    this.state.subjectsSelected = subjectsSelected;
  },
  getLevelsSelected() {
    return this.state.levelsSelected;
  },
  setLevelsSelected(levelsSelected) {
    this.state.levelsSelected = levelsSelected;
  },
  getSyllabusSelected() {
    return this.state.syllabusSelected;
  },
  setSyllabusSelected(syllabusSelected) {
    this.state.syllabusSelected = syllabusSelected;
  },
  getParentTopicsSelected() {
    return this.state.parentTopicsSelected;
  },
  setParentTopicsSelected(parentTopicsSelected) {
    this.state.parentTopicsSelected = parentTopicsSelected;
  },
  getTopicsSelected() {
    return this.state.topicsSelected;
  },
  setTopicsSelected(topicsSelected) {
    this.state.topicsSelected = topicsSelected;
  },
  getLearningOutcomeSelected() {
    return this.state.learningOutcomeSelected;
  },
  setLearningOutcomeSelected(learningOutcomeSelected) {
    this.state.learningOutcomeSelected = learningOutcomeSelected;
  },
  getParent() {
    return this.state.parent;
  },
  setParent(parent) {
    this.state.parent = parent;
  },
  setSubjectData(subjectData) {
    this.state.subjectData = subjectData;
  },
  getSubjectData() {
    return this.state.subjectData;
  },
  setLevelAndStreamData(levelAndStreamData) {
    this.state.levelAndStreamData = levelAndStreamData;
  },
  getLevelAndStreamData() {
    return this.state.levelAndStreamData;
  },
  setContentMapData(contentMapData) {
    this.state.contentMapData = contentMapData;
  },
  getContentMapData() {
    return this.state.contentMapData;
  },
  setLevelAndStreamByGroup(levelAndStreamByGroup) {
    this.state.levelAndStreamByGroup = levelAndStreamByGroup;
  },
  getLevelAndStreamByGroup() {
    return this.state.levelAndStreamByGroup;
  },
  getAuthorsAndCollaborators() {
    return this.state.authorsAndCollaborators;
  },
  setAuthorsAndCollaborators(authorsAndCollaborators) {
    this.state.authorsAndCollaborators = authorsAndCollaborators;
  },
  getAuthorAndCollaboratorIds() {
    return this.state.authorAndCollaboratorIds;
  },
  setAuthorAndCollaboratorIds(authorAndCollaborators) {
    this.state.authorAndCollaboratorIds = authorAndCollaborators;
  },
  getSearchKeyword() {
    return this.state.search.keyword;
  },
  setSearchKeyword(keyword) {
    if (this.state.search) {
      this.state.search.keyword = keyword;
    } else {
      this.state.search = {
        keyword: keyword,
      };
    }
  },
  getHasResourceFilter() {
    return this.state.search.hasResourceFilter;
  },
  setHasResourceFilter(value) {
    if (this.state.search) {
      this.state.search.hasResourceFilter = value;
    } else {
      this.state.search = {
        hasResourceFilter: value,
      };
    }
  },
  getSelectionByUuid(uuid) {
    return this.state.selectionList[uuid];
  },
  getSelectionList() {
    return this.state.selectionList;
  },
  setSelectionList(data) {
    this.state.selectionList[data.uuid] = data;
  },
  removeSelectionList(uuid) {
    delete this.state.selectionList[uuid];
  },
  clearSelectionList() {
    this.state.selectionList = {};
  },
  getQuestionPartsSelectionByUuid(uuid) {
    return this.state.questionPartsSelectionList[uuid];
  },
  getQuestionPartsSelectionList() {
    return this.state.questionPartsSelectionList;
  },
  setQuestionPartsSelectionList(data) {
    this.state.questionPartsSelectionList[data.uuid] = data;
  },
  removeQuestionPartsSelectionList(uuid) {
    delete this.state.questionPartsSelectionList[uuid];
  },
  clearQuestionPartsSelectionList() {
    this.state.questionPartsSelectionList = {};
  },
  getSearchPage() {
    return this.state.search.page;
  },
  setSearchPage(pageIdx) {
    this.state.search.page = pageIdx - 1;
  },
  removeSearchPage() {
    delete this.state.search.page;
  },
  isCardView() {
    return this.state.cardView;
  },
  destroy() {
    this.state = {
      search: {
        page: 0,
        keyword: "",
        hasResourceFilter: false,
      },
      selectionList: {},
      questionPartsSelectionList: {},
      subjectData: [],
      levelAndStreamData: {},
      subjectsSelected: [],
      levelsSelected: [],
      parentTopicsSelected: [],
      topicsSelected: [],
      learningOutcomeSelected: [],
      parent: "",
      syllabusSelected: null,
      resourceSelected: "",
    };
  },
};
